import { render, staticRenderFns } from "./PaymentBonuses.vue?vue&type=template&id=5c371a02"
import script from "./PaymentBonuses.vue?vue&type=script&lang=js"
export * from "./PaymentBonuses.vue?vue&type=script&lang=js"
import style0 from "./PaymentBonuses.vue?vue&type=style&index=0&id=5c371a02&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports